<template>
  <div class="code-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')" title="外观" name="1">
          <div class="setting-item" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
            <div class="content">
              <div class="content-item">
                <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
              </div>
              <widthAndSizeAndZindex :options="options" :ids="ids" showSetItem="rotate" class="mt12"
                v-if="request_prefix !== 'bigScreen'" />
              <div class="verticallyCenter mt12">
                <span class="mr16">二维码颜色</span>
                <cx-color-picker class="flex1 lableWidth4" :isThemeColor.sync="codeColorIsTheme"
                  :colorArr.sync="codeColor">
                </cx-color-picker>
              </div>
              <div class="verticallyCenter mt12">
                <span class="mr16 verticallyCenter" style="width: 70px;">复杂度<i class="tips-btn icon-portal-info2" @click="explainDialogClick()"></i></span>
                <cx-select
                  style="width: 140px;"
                  title=""
                  :selectOptions="correctLevelList"
                  :value.sync="correctLevel"
                />
              </div>
              <cx-background :background.sync="background" imgType="10" class="mt12" :options="options"
                :hasAddBtn="false" />
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item v-show="$store.state.states.showPluginSetting"
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')" title="插件" name="2">
          <div class="setting-item" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
            <elementPluginSetting :pluginName="pluginName" :myid="ids"></elementPluginSetting>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <div class="fs14 tips">
        <span>复杂度：</span>二维码中包含的内容长度决定了二维码图案的复杂度；若二维码尺寸较小且码点过于密集，可以选择降低复杂度。
        <p>高：复杂度高，容错率30%。</p>
        <p>较高：复杂度较高，容错率25%。</p>
        <p>中：复杂度中等，容错率15%。</p>
        <p>低：复杂度低，容错率7%。</p>
        <p>注意：二维码容错率即是指二维码图标被遮挡多少后，仍可以被扫描出来的能力。容错率越高，则二维码图片能被遮挡的部分越多。</p>
      </div>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import widthAndSizeAndZindex from "publicSetting/widthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
export default {
  name: "code-options-setting",
  components: { controlWidthAndSizeAndZindex, widthAndSizeAndZindex, TextSettingComplex, elementPluginSetting },
  props: { options: Object },
  data() {
    return {
      defaultImage: require("assets/images/image_placeholder.png"),
      this1: this,
      collapseActiveNames: ["1", "2"],
      activeNames: ["1", "2"],
      allCollapseNames: ["3", "4", "5", "6"],
      hoverOpt: [],
      activeType: 1,
      sliderMax: 360,
      correctLevelList: [
        {
          label: "低",
          value: "L"
        },
        {
          label: "中",
          value: "M"
        },
        {
          label: "较高",
          value: "Q"
        },
        {
          label: "高",
          value: "H"
        }
      ],
      explainDialog: false,
      explainImgSrc: "",
      explainVideoSrc: ""
    }
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    width: {
      get() {
        return this.options.width || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    left: {
      get() {
        return this.options.left || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "left", false)
      }
    },
    top: {
      get() {
        return this.options.top || 0
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "top", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.options.bgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.bgColorIsThemeColor,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "background", false)
      }
    },
    codeColor: {
      get() {
        return this.options.codeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "codeColor", false)
      }
    },
    codeColorIsTheme: {
      get() {
        return this.options.codeColorIsTheme
      },
      set(val) {
        this.$changeOptionsEV(val, "codeColorIsTheme", false)
      }
    },
    rotate: {
      get() {
        return parseInt(this.options.rotate)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rotate", false)
      }
    },
    opacity: {
      get() {
        return this.options.hasOwnProperty("opacity") ? parseInt(this.options.opacity * 100) : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal / 100, "opacity", false)
      }
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    correctLevel: {
      get() {
        return this.options.hasOwnProperty("correctLevel") ? this.options.correctLevel : "H"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "correctLevel", false)
      }
    }
  },
  methods: {
    switchHandle(type) {
      this.activeType = type
    },
    handleChange() { },
    getFocus(event) {
      event.currentTarget.select()
    },
    explainDialogClick() {
      this.explainDialog = true
    }
  }
}
</script>
